angular.module('hcap-analytics')
.directive('sidebar', [
  '$location',
  '$state',
  'UserService',
  'AssessmentService',
  'InvitesService',
  'PortalSectionService',
  'DevPlanService',
  'Util',
  'CohortsService',
  function(
    $location,
    $state,
    UserService,
    AssessmentService,
    InvitesService,
    PortalSectionService,
    DevPlanService,
    Util,
    CohortsService,
  ) {
    return {
      templateUrl: 'templates/sidebar.html',
      restrict: 'E',
      link: function($scope, $element, $attrs) {
        let allAssessments = [];

        const xs = Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < 834;
        $scope.pageNames = {
          home: 'My Dashboard',
          moral: 'Moral Character',
          self: 'Self Leadership',
          team_self: 'My Teams (Basic)',
          team: 'My Teams',
          cohorts: 'Teams Management',
          rel: 'Relationship Builder',
          leader: 'Leading Others',
          plans: 'My Development Plans',
          org: 'My Organization',
          profile: 'My Profile',
          invites: 'Pending Invites',
        };
        $scope.portalPageNames = {
          CSM: {
            cohorts: 'Cohort Management',
          },
        };

        $scope.open = !xs;
        $scope.secondaryOpen = false;
        $scope.sectionSelected = localStorage.getItem('sectionSelected');
        $scope.secondarySection = null;
        $scope.secondarySectionId = null;
        $scope.assessments = [];
        $scope.canManageCohorts = UserService.canManagePortal($state.params.portal);
        $scope.noticeCount = 0;
        $scope.going = false;
        $scope.sidebarSections = [];
        $scope.showTeamsModule = true;
        $scope.allowedAssessmentIds = null;
        $scope.teamsModuleOverride = null;
        $scope.portalFeatures = null;
        $scope.cohortId = null;

        AssessmentService.getUserSelfAssessments().then(function(assessments) {
          allAssessments = assessments;

          if ($scope.secondarySectionId) {
            $scope.updateAssessments($scope.secondarySectionId);
          }
        });

        CohortsService.getLatestAssessmentAccess($state.params.portal).then(function(access) {
          $scope.allowedAssessmentIds = access.assessments ? access.assessments.map(a => a.assessmentId) : null;
          $scope.teamsModuleOverride = access.showTeamsModule != null ? access.showTeamsModule : null;
          $scope.portalFeatures = access.features || null;
          $scope.cohortId = access.cohortId || null;
          $scope.refreshSections();
        });

        $scope.$watch(() => InvitesService.noticeCount, newVal => {
          $scope.noticeCount = newVal;
        });

        $scope.toggleMain = function() {
          $scope.open = !$scope.open;

          if (!$scope.open) {
            $scope.secondaryOpen = false;
          }
        };

        $scope.openSecondary = function(section) {
          $scope.secondaryOpen = true;
          $scope.updateAssessments(section);
        };

        $scope.closeSecondary = function() {
          $scope.secondaryOpen = false;
        };

        $scope.signOut = function() {
          UserService.signOut();
        };

        $scope.select = function(section) {
          try {
            localStorage.setItem('sectionSelected', section);
          } catch (e) {}
          $scope.sectionSelected = section;
          $scope.closeSecondary();
          $scope.updateTitle();

          if (xs) {
            $scope.open = false;
          }
        };

        $scope.titleSelect = () => {
          if (!xs) {
            $scope.select('home');
            $state.go('dashboard', {
              portal: $state.params.portal,
            });
          }
        };

        $scope.updateTitle = () => {
          $scope.sectionTitle = !xs ? 'My Dashboard' : $scope.getPageName($scope.sectionSelected);
        };

        $scope.assessmentCompleted = (assessment) => {
          return assessment.participant && assessment.participant.completed;
        };

        $scope.updateAssessments = section => {
          $scope.secondarySection = PortalSectionService.getSection($state.params.portal, section);

          $scope.assessments = PortalSectionService.getExpandedAssessments($state.params.portal, section, $scope.allowedAssessmentIds).map(a => {
            const assessment = allAssessments.find(aa => aa.guid === a.id && aa.participant);
            const disabled = a.disabled && (!assessment || !$scope.assessmentCompleted(assessment));

            return {
              ...assessment,
              ...a,
              disabled,
            };
          });

          $scope.secondarySectionId = section;
        };

        $scope.assessmentClick = (assessment) => {
          if (!$scope.going) {
            $scope.going = true;
            $scope.select($scope.secondarySectionId);

            Util.viewAssessment(assessment.id, assessment.templateGuid || assessment.template_guid, assessment.participant, $scope.cohortId).finally(() => {
              $scope.going = false;
            });
          }
        };

        $scope.assessmentClass = (a) => {
          return a.disabled ? 'text-grey' : 'text-' + $scope.secondarySection.styleName;
        };

        $scope.openTeamsManagement = () => {
          $scope.select('cohorts');
          $state.go('cohorts', {
            portal: $state.params.portal,
          });
        };

        $scope.sectionClass = sectionId => {
          return sectionId === 'rel' ? 'relationship' : sectionId;
        };

        $scope.getPageName = sectionId => {
          const pageNames = {
            ...$scope.pageNames,
            ...($scope.portalPageNames[$state.params.portal] || {}),
          };
          return pageNames[sectionId];
        };

        $scope.refreshSections = () => {
          const features = $scope.portalFeatures;

          $scope.sidebarSections = PortalSectionService.getSidebarSections(
            $state.params.portal,
            $scope.allowedAssessmentIds,
            features && features.sidebarSectionIds,
          );
          $scope.showOrganization = features ?
            features.showOrganization :
            PortalSectionService.showOrganization($state.params.portal);
          $scope.showTeamsModule = $scope.teamsModuleOverride != null ?
            $scope.teamsModuleOverride :
            PortalSectionService.showTeamsModule($state.params.portal);
        };

        (async () => {
          const plan = await DevPlanService.get();
          const stats = DevPlanService.stats(plan);
          $scope.plansStarted = stats.started;
          $scope.plansCompleted = stats.completed;
        })();

        $scope.name = UserService.getUser()?.name;

        $scope.$watch(() => $state.params.portal, () => {
          $scope.canManageCohorts = UserService.canManagePortal($state.params.portal);
          $scope.refreshSections();
        });

        $scope.refreshSections();
        $scope.updateTitle();
        InvitesService.update();
      },
    };
  },
]);
